import { isEqual } from 'lodash';
import React from 'react';
import CustomSelect from '../../../components/forms/CustomSelect';
import CustomTextDelayInput from '../../../components/forms/CustomTextDelayInput';
import DateField from '../../../components/forms/DateField';
import { FilterOptions } from '../../../hooks/useFilters';

interface RoutesFiltersProps {
    updateFilters: (filters: any) => void
    filters: FilterOptions
}

const RoutesFilters: React.FC<RoutesFiltersProps> = ({ filters, updateFilters }) => {

    return (
        <>
            <CustomTextDelayInput
                id="name"
                label="Buscar por nombre"
                placeholder="Añade al busqueda"
                filters={filters}
                updateFilters={updateFilters}
            />

            <CustomTextDelayInput
                id="description"
                label="Buscar por descripción"
                placeholder="Añade la busqueda"
                filters={filters}
                updateFilters={updateFilters}
            />

            <CustomTextDelayInput
                id="maxRadioInclusion"
                label="Radio de inclusión (max)"
                placeholder="Añade el radio (max)"
                filters={filters}
                updateFilters={(value: string) => updateFilters(value ?? { maxRadioInclusion: null })}
                type="number"
                isClearable
                onClear={() => updateFilters({ maxRadioInclusion: null })}
            />

            <CustomTextDelayInput
                id="minRadioInclusion"
                label="Radio de inclusión (min)"
                placeholder="Añade el radio (min)"
                filters={filters}
                updateFilters={(value: string) => updateFilters(value ?? { minRadioInclusion: null })}
                type="number"
                isClearable
                onClear={() => updateFilters({ minRadioInclusion: null })}
            />

            <CustomSelect
                isSearchable
                id={'status'}
                label="Estado"
                options={[
                    { label: 'Todos', value: 'null' },
                    { label: 'Activos', value: true },
                    { label: 'Desactivados', value: false }
                ]}
                onChange={(e: any) => {
                    if (e.value === 'null') {
                        updateFilters({ status: null });
                        return;
                    }
                    updateFilters({ status: e.value });
                }}
                value={filters.filter_filters?.status !== null && filters.filter_filters?.status !== undefined
                    ? { label: filters.filter_filters?.status ? 'Activos' : 'Desactivados', value: filters.filter_filters?.status }
                    : { label: 'Todos', value: 'null' }}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fecha de Creación"
                placeholderText="Selecciona las fechas"
                selectedDateField={filters.filter_filters?.between_dates?.type || "createdAt"}
                dateTypesOptions={[
                    { label: "Fecha de creación", value: "createdAt" },
                    { label: "Fecha de modificación", value: "updatedAt" }
                ]}
                startDate={filters.filter_filters?.between_dates?.startDate ? new Date(filters.filter_filters.between_dates.startDate) : null}
                endDate={filters.filter_filters?.between_dates?.endDate ? new Date(filters.filter_filters.between_dates.endDate) : null}
                onChange={(date: any) => {
                    const filters_between_dates = filters.filter_filters?.between_dates;
                    const between_dates = date ? { startDate: date[0], endDate: date[1] } : null;

                    if (between_dates && !isEqual(filters_between_dates, between_dates)) {
                        updateFilters({ between_dates: { startDate: date[0], endDate: date[1], type: date[2] } });
                    } else if (!between_dates && filters_between_dates) {
                        updateFilters({ between_dates: null });
                    }
                }}
            />
        </>
    );
};

export default RoutesFilters;